import { useCallback, useEffect, useState } from "react";

const useDelayedCallback = (delay: number, onClick: () => void): [boolean, () => void] => {
  const [triggered, setTriggered] = useState<boolean>(false);
  const onTrigger = useCallback(() => setTriggered(true), [setTriggered]);

  useEffect(
    () => {
      if (triggered) {
        const onTimeout = () => {
          onClick();
          setTriggered(false);
        };

        const timeout = setTimeout(onTimeout, delay);
        return () => clearTimeout(timeout);
      }

      return undefined;
    },
    [delay, onClick, triggered]
  );

  return [triggered, onTrigger];
};

export default useDelayedCallback;
